import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.17.6_@biomejs+biome@2.1.1_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node_b13dba37b798fed9f5b7ee32b050a439/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}